/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForServiceImpactAnalysis extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForServiceImpactAnalysis");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForServiceImpactAnalysis.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForServiceImpactAnalysis>): BackgroundJobPayloadForServiceImpactAnalysis {
        let obj = Object.assign(new BackgroundJobPayloadForServiceImpactAnalysis(), model);
        BackgroundJobPayloadForServiceImpactAnalysis.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForServiceImpactAnalysis>): BackgroundJobPayloadForServiceImpactAnalysis {
        if (!model) return null;
        return BackgroundJobPayloadForServiceImpactAnalysis.newInstance(<BackgroundJobPayloadForServiceImpactAnalysis> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForServiceImpactAnalysis) {
        if (!obj) return;

        models.BackgroundJobPayloadForServiceImpactAnalysis.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForServiceImpactAnalysis): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForServiceImpactAnalysis.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tenant ID for which the service impact analysis is to be performed
     */
    tenant_id: string;

    /**
     * Cloud provider for which service impact analysis is to be performed
     */
    cloud_provider: models.CloudServiceName;

}
